/**
 * @generated SignedSource<<23187dd7181de683eb69e39ca808b473>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type UserAdminAccounts_store$data = {
  readonly users: ReadonlyArray<{
    readonly employee: {
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
    } | null;
    readonly id: string;
    readonly role: Roles;
    readonly user: {
      readonly email: string;
      readonly id: string;
      readonly invite: {
        readonly createdAt: string;
        readonly expiresAt: string;
      } | null;
      readonly name: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"UserAdminAccountsMissingEmployee_storeUser">;
  }>;
  readonly " $fragmentType": "UserAdminAccounts_store";
};
export type UserAdminAccounts_store$key = {
  readonly " $data"?: UserAdminAccounts_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserAdminAccounts_store">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAdminAccounts_store",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreUser",
      "kind": "LinkedField",
      "name": "users",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserInvite",
              "kind": "LinkedField",
              "name": "invite",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "expiresAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "role",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAdminAccountsMissingEmployee_storeUser"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Avatar_employee"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};
})();

(node as any).hash = "5b80fe3a704484bb7e107055bd4e33a9";

export default node;
